__turbopack_context__.v({
  "aboutSection": "MobileAbout-module__8U1diG__aboutSection",
  "backgroundImage": "MobileAbout-module__8U1diG__backgroundImage",
  "description": "MobileAbout-module__8U1diG__description",
  "heroSection": "MobileAbout-module__8U1diG__heroSection",
  "heroText": "MobileAbout-module__8U1diG__heroText",
  "mobileContainer": "MobileAbout-module__8U1diG__mobileContainer",
  "productCard": "MobileAbout-module__8U1diG__productCard",
  "productImageWrapper": "MobileAbout-module__8U1diG__productImageWrapper",
  "productName": "MobileAbout-module__8U1diG__productName",
  "productsGrid": "MobileAbout-module__8U1diG__productsGrid",
  "productsSection": "MobileAbout-module__8U1diG__productsSection",
  "sectionTitle": "MobileAbout-module__8U1diG__sectionTitle",
  "subtitle": "MobileAbout-module__8U1diG__subtitle",
});
